/**
 * Round 130 (R130-5) - "sign in first if needed". An email's "Open in the app" button points at a page inside the app (for a support reply:
 * /messages?ticket=<id>). A learner who is signed out is sent to the welcome page; this remembers where they were going for the tab's lifetime
 * and sends them there after sign-in - but only ever to a path inside the app (a single leading slash, never a full URL), and only when the
 * normal landing page is where sign-in would have taken them anyway (an unfinished onboarding step always comes first).
 */
const KEY = 'emi.returnTo';
const SAFE = /^\/(?!\/)[A-Za-z0-9\-._~%/?=&]*$/;

export function isSafeReturnPath(path: unknown): path is string {
  return typeof path === 'string' && path.length <= 300 && SAFE.test(path) && !path.startsWith('/welcome') && !path.startsWith('/sign-in') && !path.startsWith('/admin');
}
export function rememberReturnTo(path: string): void {
  if (!isSafeReturnPath(path)) return;
  try { sessionStorage.setItem(KEY, path); } catch { /* private window: the learner simply lands on the home page */ }
}
/** The remembered path (and forgets it) when the route sign-in resolved to is the normal landing; otherwise the resolved route unchanged. */
export function takeReturnTo(resolvedRoute: string): string {
  let saved: string | null = null;
  try { saved = sessionStorage.getItem(KEY); sessionStorage.removeItem(KEY); } catch { saved = null; }
  const landing = resolvedRoute === '/lessons' || resolvedRoute === '/';
  return landing && isSafeReturnPath(saved) ? saved : resolvedRoute;
}
